var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "claim-compensation-mobilier view" }, [
    _c("div", { staticClass: "view_content" }, [
      _c("div", { staticClass: "view_content_markdown" }, [
        _c("h1", [_vm._v(_vm._s(_vm.$t("claim.compensationMobilier.title")))]),
      ]),
      _c(
        "div",
        { staticClass: "claim-compensation-mobilier_total center mg mg--b-4" },
        [
          _c("p", { staticClass: "mg mg--t-3 mg--b-1" }, [
            _vm._v(_vm._s(_vm.$t("claim.compensationMobilier.totalAmount"))),
          ]),
          _c("p", { staticClass: "blueLight headline-large" }, [
            _vm._v(_vm._s(_vm.mobilierDamagesTotalAmount) + " €"),
          ]),
        ]
      ),
      _c(
        "div",
        { staticClass: "claim-compensation-mobilier_reports view_elements" },
        [
          _c("div", { staticClass: "claim-compensation-mobilier_report" }, [
            _vm.stateWarrantyHasUpptecDamage
              ? _c(
                  "div",
                  { staticClass: "file" },
                  [
                    _c("svgicon", { attrs: { icon: "ico-file" } }),
                    _c("p", { staticClass: "file_name" }, [
                      _vm._v(_vm._s(_vm.$t("damageValidation.upptecDossier"))),
                    ]),
                    _c("svgicon", {
                      attrs: { icon: "ico-download" },
                      on: { click: _vm.handleClickUppTecDossier },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ]
      ),
    ]),
    _c(
      "div",
      { staticClass: "view_actions" },
      [
        _c("ma-actions-buttons", {
          attrs: {
            handleButtonClick: _vm.handlePrimaryButtonClick,
            handleButtonClickWhiteBtn: _vm.handleSecondaryButtonClick,
            title: _vm.$t("claim.compensationMobilier.actions.primary"),
            titleWhiteBtn: _vm.$t(
              "claim.compensationMobilier.actions.secondary"
            ),
            btnType: "functionalBtnWhite",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }